if (!customElements.get("tco-card-gallery")) {
  customElements.define(
    "tco-card-gallery",
    class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;

        const track = this.querySelector(".tco-card-gallery__track");
        const slides = [
          ...this.querySelectorAll(".tco-card-gallery__slide")
        ];
        const controls = this.querySelector(
          ".tco-card-gallery__controls"
        );

        if (!track || slides.length < 2 || !controls) return;

        const previous = this.querySelector("[data-gallery-previous]");
        const next = this.querySelector("[data-gallery-next]");
        const dots = [...this.querySelectorAll("[data-gallery-index]")];
        const controller = new AbortController();
        const options = { signal: controller.signal };
        let current = 0;
        let frame = null;

        const update = () => {
          const trackLeft = track.getBoundingClientRect().left;
          let nearest = 0;
          let distance = Infinity;

          slides.forEach((slide, index) => {
            const gap = Math.abs(
              slide.getBoundingClientRect().left - trackLeft
            );

            if (gap < distance) {
              distance = gap;
              nearest = index;
            }
          });

          current = nearest;
          previous.disabled = current === 0;
          next.disabled = current === slides.length - 1;

          dots.forEach((dot, index) => {
            if (index === current) {
              dot.setAttribute("aria-current", "true");
            } else {
              dot.removeAttribute("aria-current");
            }
          });
        };

        const goTo = (index) => {
          const target = Math.max(
            0,
            Math.min(index, slides.length - 1)
          );
          const offset =
            slides[target].getBoundingClientRect().left -
            track.getBoundingClientRect().left;
          const reducedMotion = window.matchMedia(
            "(prefers-reduced-motion: reduce)"
          ).matches;

          track.scrollBy({
            left: offset,
            behavior: reducedMotion ? "auto" : "smooth"
          });
        };

        previous.addEventListener(
          "click",
          () => goTo(current - 1),
          options
        );

        next.addEventListener(
          "click",
          () => goTo(current + 1),
          options
        );

        dots.forEach((dot) => {
          dot.addEventListener(
            "click",
            () => goTo(Number(dot.dataset.galleryIndex)),
            options
          );
        });

        track.addEventListener(
          "keydown",
          (event) => {
            if (event.key === "ArrowRight") {
              event.preventDefault();
              goTo(current + 1);
            } else if (event.key === "ArrowLeft") {
              event.preventDefault();
              goTo(current - 1);
            } else if (event.key === "Home") {
              event.preventDefault();
              goTo(0);
            } else if (event.key === "End") {
              event.preventDefault();
              goTo(slides.length - 1);
            }
          },
          options
        );

        track.addEventListener(
          "scroll",
          () => {
            if (frame !== null) return;

            frame = requestAnimationFrame(() => {
              frame = null;
              update();
            });
          },
          { passive: true, signal: controller.signal }
        );

        const observer = new ResizeObserver(update);
        observer.observe(track);

        this.cleanup = () => {
          controller.abort();
          observer.disconnect();
          if (frame !== null) cancelAnimationFrame(frame);
          controls.hidden = true;
        };

        controls.hidden = false;
        update();
      }

      disconnectedCallback() {
        if (this.cleanup) {
          this.cleanup();
          this.cleanup = null;
        }
      }
    }
  );
}